import { useQuery } from "react-query";

import { planApi } from "@/react/api/planApi";

export interface UseFetchEmailHubPlanProps {
  billingCurrency?: string;
  isEnabled?: boolean;
  locale?: string;
}

export const useFetchEmailHubPlan = ({
  billingCurrency = "",
  locale = "",
  isEnabled = true,
}: UseFetchEmailHubPlanProps) => {
  const {
    data: emailHubPlan,
    isInitialLoading: isEmailHubPlanLoading,
    error: errorFetchingEmailHubPlan,
  } = useQuery({
    queryKey: ["plan", "fetch", "email_hub", billingCurrency, locale],
    queryFn: () =>
      planApi.fetchEmailHubPlan({
        billing_currency: billingCurrency,
        locale: locale,
      }),
    enabled: isEnabled,
  });

  return {
    emailHubPlan,
    isEmailHubPlanLoading,
    errorFetchingEmailHubPlan,
  };
};
